<template>
  <div class="draft-contract-form-wrapper">
    <!-- 表单区域 -->
    <div class="figma-form-card">
      <el-form ref="form" :model="formData" :rules="rules" label-width="120px" class="draft-contract-form">
        <el-row :gutter="24">
          <!-- 第一列 -->
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.community')" prop="communityId">
              <el-select
                v-model="formData.communityId"
                :placeholder="$t('committeeDraftContract.placeholder.selectCommunity')"
                class="figma-form-control"
                @change="handleCommunityChange"
              >
                <el-option v-for="item in communityList" :key="item.communityId" :label="item.name" :value="item.communityId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.contractName')" prop="contractName">
              <el-input v-model="formData.contractName" :placeholder="$t('committeeDraftContract.placeholder.enterContractName')" class="figma-form-control" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.contractCode')" prop="contractCode">
              <el-input v-model="formData.contractCode" :placeholder="$t('committeeDraftContract.placeholder.enterContractCode')" class="figma-form-control" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.contractType')" prop="contractType">
              <el-select
                v-model="formData.contractType"
                :placeholder="$t('committeeDraftContract.placeholder.selectContractType')"
                class="figma-form-control"
                @change="handleContractTypeChange"
              >
                <el-option v-for="item in contractTypes" :key="item.contractTypeId" :label="item.typeName" :value="item.contractTypeId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.partyA')" prop="partyA">
              <el-select
                v-model="formData.partyA"
                :placeholder="$t('committeeDraftContract.placeholder.selectPartyA')"
                class="figma-form-control"
                @change="handlePartyAChange"
              >
                <el-option v-for="item in partyAList" :key="item.partyA" :label="item.partyA" :value="item.partyA" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.partyAPhone')">
              <el-input v-model="formData.aLink" disabled class="figma-form-control figma-form-control-readonly" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.partyB')" prop="partyB">
              <el-input v-model="formData.partyB" disabled class="figma-form-control figma-form-control-partyb" :placeholder="$t('committeeDraftContract.placeholder.selectPartyB')" />
              <el-button type="primary" size="small" class="partyb-select-btn" @click="openSearchOwner">{{ $t('committeeDraftContract.action.select') }}</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.partyBPhone')">
              <el-input v-model="formData.bLink" disabled class="figma-form-control figma-form-control-readonly" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.operator')" prop="operator">
              <el-input v-model="formData.operator" :placeholder="$t('committeeDraftContract.placeholder.enterOperator')" class="figma-form-control" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.operatorPhone')" prop="operatorLink">
              <el-input v-model="formData.operatorLink" :placeholder="$t('committeeDraftContract.placeholder.enterPhone')" class="figma-form-control" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.contractAmount')">
              <el-input v-model="formData.amount" :placeholder="$t('committeeDraftContract.placeholder.enterAmount')" class="figma-form-control" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.startTime')" prop="startTime">
              <el-date-picker
                v-model="formData.startTime"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$t('committeeDraftContract.placeholder.selectDate')"
                class="figma-form-control"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.endTime')" prop="endTime">
              <el-date-picker
                v-model="formData.endTime"
                type="date"
                value-format="yyyy-MM-dd"
                :placeholder="$t('committeeDraftContract.placeholder.selectDate')"
                class="figma-form-control"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.signingTime')" prop="signingTime">
              <el-date-picker
                v-model="formData.signingTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('committeeDraftContract.placeholder.selectDate')"
                class="figma-form-control"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 合同附件 -->
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item :label="$t('committeeDraftContract.form.contractAttachments')" prop="contractFilePo">
              <div class="attachment-area">
                <el-button size="small" class="figma-btn-add-attachment" @click="addFileStep">
                  <img src="../../../assets/CodeBuddyAssets/616_41203/35.svg" class="attachment-icon" />
                  <span>{{ $t('committeeDraftContract.action.addAttachment') }}</span>
                </el-button>
                <div v-for="(item, index) in formData.contractFilePo" :key="index" class="attachment-item">
                  <div class="attachment-info">
                    <img src="../../../assets/CodeBuddyAssets/616_41203/36.svg" class="file-icon" />
                    <span class="file-name">{{ item.fileRealName || '未选择文件' }}</span>
                    <a class="file-delete" @click="deleteStep(item, index)">
                      <img src="../../../assets/CodeBuddyAssets/616_41203/37.svg" class="delete-icon" />
                    </a>
                  </div>
                  <input type="file" class="hidden-file-input" :ref="'fileInput' + index" @change="getFile($event, index)" accept=".png,.pdf,.jpg" />
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 关联房屋 -->
    <div class="figma-form-card figma-related-rooms-card">
      <div class="related-rooms-header">
        <span class="related-rooms-title">{{ $t('committeeDraftContract.action.relatedRooms') }}</span>
        <el-button size="small" class="figma-btn-add-room" @click="openSearchRoom">
          <img src="../../../assets/CodeBuddyAssets/616_41203/38.svg" class="add-room-icon" />
          <span>{{ $t('committeeDraftContract.action.addRoom') }}</span>
        </el-button>
      </div>
      <el-table :data="formData.rooms" style="width: 100%" :header-cell-style="roomHeaderStyle" :cell-style="roomCellStyle">
        <el-table-column prop="floorNum" :label="$t('committeeDraftContract.form.room')" min-width="240">
          <template slot-scope="scope">
            {{ scope.row.floorNum }}-{{ scope.row.unitNum }}-{{ scope.row.roomNum }}
          </template>
        </el-table-column>
        <el-table-column prop="ownerName" :label="$t('committeeDraftContract.form.owner')" min-width="247" />
        <el-table-column prop="link" :label="$t('committeeDraftContract.form.phone')" min-width="348" />
        <el-table-column prop="builtUpArea" :label="$t('committeeDraftContract.form.builtUpArea')" min-width="380">
          <template slot-scope="scope">
            {{ scope.row.builtUpArea }}{{ $t('committeeDraftContract.form.squareMeter') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('committeeDraftContract.form.roomStatus')" min-width="194">
          <template slot-scope="scope">
            <span :class="['room-status-tag', getRoomStatusClass(scope.row)]">{{ scope.row.stateName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('committeeDraftContract.table.action')" min-width="171">
          <template slot-scope="scope">
            <a class="action-delete-link" @click="removeRoom(scope.row)">{{ $t('committeeDraftContract.action.delete') }}</a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 按钮区域 -->
    <div class="figma-form-footer">
      <el-button class="figma-btn-cancel" @click="handleCancel">{{ $t('committeeDraftContract.action.cancel') }}</el-button>
      <el-button class="figma-btn-submit" @click="handleSubmit">{{ $t('committeeDraftContract.action.submit') }}</el-button>
    </div>

    <!-- 弹窗 -->
    <search-room ref="searchRoom" @chooseRoom="handleChooseRoom" />
    <search-owner ref="searchOwner" :community-id="formData.communityId" @chooseOwner="handleChooseOwner" />
  </div>
</template>

<script>
import { queryContractType, queryContractTypeSpec, saveContract } from '@/api/contract/addContractApi'
import { updateContract } from '@/api/contract/contractManageApi'
import { queryContractPartya } from '@/api/contract/contractPartyaManageApi'
import { listCommunitysByOwnerCommittee } from '@/api/owner/ownerCommitteeManageApi'
import { uploadFile } from '@/api/system/paymentPoolApi'
import SearchRoom from '@/components/room/searchRoom'
import SearchOwner from '@/components/owner/SearchOwner'

export default {
  name: 'DraftContractForm',
  components: { SearchRoom, SearchOwner },
  props: {
    communityList: {
      type: Array,
      default: () => []
    },
    editData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      formData: {
        communityId: '',
        contractName: '',
        contractCode: '',
        contractType: '',
        contractParentId: '',
        partyA: '',
        aContacts: '',
        aLink: '',
        partyB: '',
        bContacts: '',
        bLink: '',
        operator: '',
        amount: '',
        startTime: '',
        endTime: '',
        signingTime: '',
        contractFilePo: [],
        rooms: [],
        objType: '1111',
        objId: '-1',
        audit: '',
        contractTypeSpecs: []
      },
      contractTypes: [],
      partyAList: [],
      rules: {
        communityId: [{ required: true, message: this.$t('committeeDraftContract.message.requiredField'), trigger: 'change' }],
        contractName: [{ required: true, message: this.$t('committeeDraftContract.message.requiredField'), trigger: 'blur' }],
        contractCode: [{ required: true, message: this.$t('committeeDraftContract.message.requiredField'), trigger: 'blur' }],
        contractType: [{ required: true, message: this.$t('committeeDraftContract.message.requiredField'), trigger: 'change' }],
        partyA: [{ required: true, message: this.$t('committeeDraftContract.message.requiredField'), trigger: 'change' }],
        partyB: [{ required: true, message: this.$t('committeeDraftContract.message.requiredField'), trigger: 'change' }],
        operator: [{ required: true, message: this.$t('committeeDraftContract.message.requiredField'), trigger: 'blur' }],
        operatorLink: [{ required: true, message: this.$t('committeeDraftContract.message.requiredField'), trigger: 'blur' }],
        startTime: [{ required: true, message: this.$t('committeeDraftContract.message.requiredField'), trigger: 'change' }],

        signingTime: [{ required: true, message: this.$t('committeeDraftContract.message.requiredField'), trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadContractTypes()
    this.loadPartyAList()
    if (this.editData) {
      this.loadEditData()
    } else {
      this.setDefaultCommunity()
    }
  },
  methods: {
    roomHeaderStyle() {
      return { background: '#EBF2FA', color: '#364153', fontSize: '14px', fontWeight: '400', fontFamily: 'PingFang SC', height: '50px' }
    },
    roomCellStyle({ row, columnIndex, rowIndex }) {
      const base = { color: '#1D2129', fontSize: '14px', fontFamily: 'PingFang SC', height: '50px', fontWeight: rowIndex % 2 === 1 ? '500' : '400' }
      return rowIndex % 2 === 1 ? { ...base, background: '#F8FBFF' } : { ...base, background: 'white' }
    },
    getRoomStatusClass(row) {
      const text = String(row.stateName || '')
      if (text.includes('入住') || text.includes('入住')) return 'room-status-active'
      if (text.includes('未售') || text.includes('空置')) return 'room-status-inactive'
      return 'room-status-default'
    },
    setDefaultCommunity() {
      if (this.communityList.length > 0) {
        this.formData.communityId = this.communityList[0].communityId
      }
    },
    loadEditData() {
      const data = this.editData
      this.formData = {
        ...this.formData,
        contractId: data.contractId,
        communityId: data.communityId || '',
        contractName: data.contractName || '',
        contractCode: data.contractCode || '',
        contractType: data.contractType || '',
        contractParentId: data.contractParentId || '',
        partyA: data.partyA || '',
        aContacts: data.aContacts || '',
        aLink: data.aLink || '',
        partyB: data.partyB || '',
        bContacts: data.bContacts || '',
        bLink: data.bLink || '',
        operator: data.operator || '',
        operatorLink: data.operatorLink || '',
        amount: data.amount || data.contractAmount || '',
        startTime: data.startTime || '',
        endTime: data.endTime || '',
        signingTime: data.signingTime || '',
        rooms: data.rooms || [],
        objType: data.objType || '1111',
        objId: data.objId || '-1',
        audit: data.audit || '',
        contractTypeSpecs: data.contractTypeSpecs || []
      }
      if (data.contractType) {
        this.handleContractTypeChange(data.contractType)
      }
    },
    async loadContractTypes() {
      try {
        const res = await queryContractType({ page: 1, row: 1000, communityIds: this.communityList.map(c => c.communityId).join(',') })
        this.contractTypes = res.data || []
      } catch (e) {
        this.contractTypes = []
      }
    },
    async loadPartyAList() {
      try {
        const res = await queryContractPartya({ page: 1, row: 1000, communityIds: this.communityList.map(c => c.communityId).join(',') })
        this.partyAList = res.data || []
      } catch (e) {
        this.partyAList = []
      }
    },
    handleCommunityChange(communityId) {
      this.formData.communityId = communityId
    },
    handleContractTypeChange(val) {
      this.contractTypes.forEach(item => {
        if (val === item.contractTypeId) {
          this.formData.audit = item.audit
        }
      })
      this.formData.contractTypeSpecs = []
      queryContractTypeSpec({ page: 1, row: 100, contractTypeId: val }).then(res => {
        const specs = []
        ;(res.data || []).forEach(item => {
          item.value = ''
          if (item.specShow === 'Y') {
            item.values = []
            specs.push(item)
          }
        })
        this.formData.contractTypeSpecs = specs
      })
    },
    handlePartyAChange(val) {
      this.partyAList.forEach(item => {
        if (val === item.partyA) {
          this.formData.aLink = item.aLink || ''
          this.formData.aContacts = item.aContacts || ''
        }
      })
    },
    openSearchOwner() {
      this.$refs.searchOwner.open()
    },
    openSearchRoom() {
      this.$refs.searchRoom.open()
    },
    handleChooseOwner(owner) {
      this.formData.partyB = owner.name || ''
      this.formData.bContacts = owner.name || ''
      this.formData.bLink = owner.link || ''
      this.formData.objId = owner.ownerId || '-1'
    },
    handleChooseRoom(room) {
      const exists = this.formData.rooms.find(r => r.roomId === room.roomId)
      if (!exists) {
        this.formData.rooms.push(room)
      }
    },
    removeRoom(room) {
      this.formData.rooms = this.formData.rooms.filter(r => r.roomId !== room.roomId)
    },
    addFileStep() {
      const index = this.formData.contractFilePo.length
      this.formData.contractFilePo.push({ seq: index, fileSaveName: '', fileRealName: '' })
      this.$nextTick(() => {
        const ref = this.$refs['fileInput' + index]
        if (ref && ref[0]) ref[0].click()
        else if (ref) ref.click()
      })
    },
    deleteStep(item, index) {
      this.formData.contractFilePo.splice(index, 1)
      this.formData.contractFilePo.forEach((f, i) => { f.seq = i })
    },
    getFile(e, index) {
      const file = e.target.files[0]
      if (!file) return
      const suffix = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
      if (!['png', 'pdf', 'jpg'].includes(suffix)) {
        this.$message.error(this.$t('committeeDraftContract.message.invalidFileType'))
        return
      }
      this.formData.contractFilePo[index].fileRealName = file.name
      const formData = new FormData()
      formData.append('uploadFile', file)
      uploadFile(formData, {}).then(data => {
        this.formData.contractFilePo[index].fileSaveName = data.realFileName || ''
      }).catch(() => {
        this.$message.error(this.$t('committeeDraftContract.message.saveError'))
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const data = {
          ...this.formData,
          communityId: this.formData.communityId
        }
        const api = this.editData ? updateContract : saveContract
        api(data).then(res => {
          if (res.code === 0 || res.code === 200 || res.code === '0' || res.code === '200') {
            this.$message.success(this.$t('committeeDraftContract.message.saveSuccess'))
            this.$emit('success')
          } else {
            this.$message.error(res.msg || this.$t('committeeDraftContract.message.saveError'))
          }
        }).catch(() => {
          this.$message.error(this.$t('committeeDraftContract.message.saveError'))
        })
      })
    },
    handleCancel() {
      this.$emit('back')
    },
    resetForm() {
      this.formData = {
        communityId: '',
        contractName: '',
        contractCode: '',
        contractType: '',
        contractParentId: '',
        partyA: '',
        aContacts: '',
        aLink: '',
        partyB: '',
        bContacts: '',
        bLink: '',
        operator: '',
        amount: '',
        startTime: '',
        endTime: '',
        signingTime: '',
        contractFilePo: [],
        rooms: [],
        objType: '1111',
        objId: '-1',
        audit: '',
        contractTypeSpecs: []
      }
      this.setDefaultCommunity()
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate()
      })
    }
  }
}
</script>

<style scoped>
.draft-contract-form-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.figma-form-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
}

.figma-related-rooms-card {
  padding-bottom: 16px;
}

.draft-contract-form >>> .el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.draft-contract-form >>> .el-form-item__label {
  line-height: 38px;
  height: 38px;
  float: none;
  flex-shrink: 0;
  text-align: right;
  padding-right: 8px;
  color: #1D2129;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC';
}

.draft-contract-form >>> .el-form-item__content {
  flex: 1;
  margin-left: 0 !important;
  line-height: 38px;
}

.figma-form-control {
  width: 100%;
  height: 38px;
}

.figma-form-control >>> .el-input__inner {
  height: 38px !important;
  line-height: 38px !important;
  border-radius: 10px;
  border: none;
  outline: 1px #DCE6F5 solid;
  outline-offset: -1px;
  color: #1D2129;
  font-size: 14px;
  background: white;
}

.figma-form-control >>> .el-input__inner::placeholder {
  color: #8C9BB4;
}

.figma-form-control >>> .el-input__inner:focus {
  outline-color: #0E76FF;
}

.figma-form-control >>> .el-input__inner:disabled {
  background: #F1F6FA;
  color: #1D2129;
  cursor: not-allowed;
}

.figma-form-control-readonly >>> .el-input__inner {
  background: #F1F6FA;
}

/* 乙方输入框+选择按钮 */
.figma-form-control-partyb {
  width: calc(100% - 70px) !important;
  display: inline-block !important;
  vertical-align: middle;
}

.partyb-select-btn {
  margin-left: 8px;
  vertical-align: middle;
  border-radius: 10px;
  height: 38px;
}

/* 附件区域 */
.attachment-area {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.figma-btn-add-attachment {
  width: 114px;
  height: 38px;
  border-radius: 10px;
  border: 1px #0E76FF solid;
  background: white;
  color: #0E76FF;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0;
}

.attachment-icon {
  width: 16px;
  height: 16px;
}

.attachment-item {
  position: relative;
}

.attachment-info {
  height: 38px;
  background: #F3F7FB;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 8px;
}

.file-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.file-name {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #1D2129;
  font-family: 'PingFang SC';
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-delete {
  cursor: pointer;
  flex-shrink: 0;
}

.delete-icon {
  width: 16px;
  height: 16px;
}

.hidden-file-input {
  display: none;
}

/* 关联房屋 */
.related-rooms-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.related-rooms-title {
  font-size: 16px;
  font-weight: 600;
  color: #1D2129;
  font-family: 'PingFang SC';
}

.figma-btn-add-room {
  width: 82px;
  height: 38px;
  background: #0E76FF;
  border-radius: 10px;
  border: none;
  color: white;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0;
}

.add-room-icon {
  width: 16px;
  height: 16px;
}

.room-status-tag {
  display: inline-block;
  min-width: 66px;
  height: 28px;
  line-height: 26px;
  padding: 0 12px;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
}

.room-status-active {
  color: #21B956;
  background: rgba(33, 185, 86, 0.10);
  border: 1px solid #21B956;
}

.room-status-inactive {
  color: #8C9BB4;
  background: rgba(140, 155, 180, 0.10);
  border: 1px solid #8C9BB4;
}

.room-status-default {
  color: #8C9BB4;
  background: rgba(140, 155, 180, 0.10);
  border: 1px solid #8C9BB4;
}

.action-delete-link {
  color: #0E76FF;
  font-size: 14px;
  cursor: pointer;
}

.action-delete-link:hover {
  opacity: 0.85;
}

/* 底部按钮 */
.figma-form-footer {
  background: white;
  border-radius: 12px;
  padding: 28px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}

.figma-btn-cancel {
  width: 98px;
  height: 38px;
  background: white;
  border-radius: 10px;
  border: 1px #0E76FF solid;
  color: #0E76FF;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
}

.figma-btn-submit {
  width: 98px;
  height: 38px;
  background: #0E76FF;
  border-radius: 10px;
  border: none;
  color: white;
  font-size: 14px;
  font-weight: 500;
  padding: 0;
}

.figma-btn-submit:hover {
  background: #3D94FF;
}

.figma-btn-cancel:hover {
  background: rgba(14, 118, 255, 0.08);
}
</style>
